import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import localStorageNames from '@data/localStorageNames';
import { ObjectId } from 'bson';

export const useMiniappReq = create(
  persist(
    (set, get) => ({
      miniappreq: null,
      miniappreqid: '',
      miniappreqxendit: null,
      miniappreqmessage: null,
      updateMiniappReq: (newMiniapp) => {
        set({ miniappreq: newMiniapp });
      },
      updateMiniappReqId: (newMiniapp) => {
        set({ miniappreqid: newMiniapp });
      },
      updateMiniappReqXendit: (newMiniapp) => {
        set({ miniappreqxendit: newMiniapp });
      },
      updateMiniappReqMessage: (newMessage) => {
        set({ miniappreqmessage: newMessage });
      },
      getMiniappReq: () => {
        return get().miniappreq;
      },
      getMiniappReqId: () => {
        return get().miniappreqid;
      },
      getMiniappReqXendit: () => {
        return get().miniappreqxendit;
      },
      getMiniappReqMessage: () => {
        return get().miniappreqmessage;
      },
    }),
    {
      name: localStorageNames.MINIAPP_REQ,
    },
  ),
);
